// extracted by mini-css-extract-plugin
export default {"mobileNav":"mobileNav_mobileNav__W3HgU","menuTitle":"mobileNav_menuTitle__uiFFY"};